import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { TasksService } from 'app/modules/admin/apps/task-list/task-list.service';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../user/user.service';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {
	private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

	/**
	 * Constructor
	 */
	constructor(
		private _httpClient: HttpClient,
		private taskListService: TasksService,
		private userService: UserService
	) { }

	// -----------------------------------------------------------------------------------------------------
	// @ Accessors
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Getter for navigation
	 */
	get navigation$(): Observable<Navigation> {
		return this._navigation.asObservable();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Get all navigation data
	 */
	get(): Observable<Navigation> {

		return this._httpClient.get<Navigation>('api/common/navigation').pipe(
			map((navigation) => {
				navigation.default.forEach((item, _index) => {
					if (item.id === 'tasks') {
						item.badge = {
							title: '0',
							classes: 'px-2.5 bg-primary-400 text-black rounded-full'
						};
					}
				});

				const userPermissions = this.userService.getAllUserGroups();
				//navigation.default = this.filterNavigationByPermission(navigation.default, userPermissions);
				this._navigation.next(navigation);
				return navigation;
			})
		);
	}

	/**
	 * Filter navigation items by permission
	 */
	private filterNavigationByPermission(items: any[], permissions: string[]): any[] {
		return items
			.filter(item => {
				if (!item.auth) return true;
				return item.auth.some(auth => permissions.includes(auth));
			})
			.map(item => ({
				...item,
				children: item.children ? this.filterNavigationByPermission(item.children, permissions) : undefined
			}));
	}
}
